'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _reduxForm = require('redux-form');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _pacomo = require('utils/pacomo');

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _components2 = require('components');

var _forms = require('utils/forms');

var _forms2 = require('metadata/forms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    LOIOverride: {
        displayName: 'LOIOverride'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/RequirementSet/forms/TravelDocuments.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var applicationFormStub = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelDocuments.applicationFormStub',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'h4',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.applicationFormStubTitle',
                    defaultMessage: 'Application Form' })
            ),
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.applicationFormStubText',
                    defaultMessage: 'We require you to submit an application form to satisfy\n                                         your entry visa requirement for your destination.' })
            )
        )
    } });

var criminalBkgrdCheckStub = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelDocuments.criminalBkgrdCheckStub',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'h4',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.criminalBkgrdCheckStubTitle',
                    defaultMessage: 'Criminal Background Check' })
            ),
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.criminalBkgrdCheckStubText',
                    defaultMessage: 'We require you to submit this background check in order\n                                         to satisfy your entry visa requirement for your destination.' })
            )
        )
    } });

var letterOfRefStub = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelDocuments.letterOfRefStub',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'h4',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.letterOfRefStubTitle',
                    defaultMessage: 'Letter of Reference' })
            ),
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.letterOfRefStubText',
                    defaultMessage: 'We require you to submit this letter of reference in order\n                                         to satisfy your entry visa requirement for your destination.' })
            ),
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.letterOfRefStubTextExtra',
                    defaultMessage: 'Plus, hearing from those you know shows us how you\'re\n                                         even more awesome and incredible than we originally thought.' })
            )
        )
    } });

var passportPhotoStub = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelDocuments.passportPhotoStub',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'h4',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.passportPhotoStubTitle',
                    defaultMessage: 'Passport Photo' })
            ),
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.passportPhotoStubText',
                    defaultMessage: 'We require you to submit a scan of a colour, passport\n                                         sized photo (taken within 14 days) in jpg or pdf format\n                                         in order for us to issue some of your items.' })
            )
        )
    } });

var copyOfPassportSentStub = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelDocuments.copyOfPassportSentStub',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'h4',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.copyOfPassportSentStubTitle',
                    defaultMessage: 'Copy Of Passport Sent' })
            ),
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.copyOfPassportSentStubText',
                    defaultMessage: 'A clear, coloured copy of your passport is required for your tour.\n                        All four corners of the photo as well as adjacent page must be visible without flash, shine or shadow.' })
            )
        )
    } });

var copyOfPassportLOIStub = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelDocuments.copyOfPassportLOI',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'h4',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.copyOfPassportLOIStubTitle',
                    defaultMessage: 'Copy Of Passport LOI' })
            ),
            _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.copyOfPassportLOIStubText',
                    defaultMessage: '{stubTextLOI}',
                    values: {
                        stubTextLOI: _react3.default.createElement(
                            'div',
                            null,
                            _react3.default.createElement(
                                'p',
                                null,
                                _react3.default.createElement(
                                    'span',
                                    null,
                                    'A copy of your passport is required to complete this booking'
                                )
                            ),
                            _react3.default.createElement(
                                'p',
                                null,
                                _react3.default.createElement(
                                    'span',
                                    null,
                                    'You may require a Letter of Invitation to apply for your visas, although visa requirements vary by nationality. Please verify with the nearest consulate of the country you\u2019ll be visiting if you need a letter from the inviting company to support your visa application. If you require a Letter of Invitation, application forms can be found '
                                ),
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formTravelDocuments.copyOfPassportLOIStubText.here',
                                    defaultMessage: '{here}',
                                    values: {
                                        here: _react3.default.createElement(
                                            'a',
                                            {
                                                href: 'https://www.gadventures.com/travel-resources/visa_authorization_forms/',
                                                target: '_blank' },
                                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                                id: 'formTravelDocuments.copyOfPassportLOIStubText.tag',
                                                defaultMessage: 'here' })
                                        )
                                    }
                                }),
                                '.'
                            ),
                            _react3.default.createElement(
                                'p',
                                null,
                                _react3.default.createElement(
                                    'span',
                                    null,
                                    'Once you have submitted your application, please allow 2-3 business days to get your passport copy processed.'
                                )
                            )
                        )
                    }
                })
            )
        )
    } });

var copyOfVisaSubmittedStub = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelDocuments.copyOfVisaSubmittedStub',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'h4',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.copyOfVisaSubmittedStubTitle',
                    defaultMessage: 'Copy Of Visa Submitted' })
            ),
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelDocuments.copyOfVisaSubmittedStubText',
                    defaultMessage: 'A clear, coloured copy of your Chinese visa is required for your tour to Tibet.' })
            )
        )
    } });

var LOIOverride = _wrapComponent('LOIOverride')((_dec = (0, _reduxUi2.default)(), _dec(_class = (0, _pacomo.pacomoDecorator)(_class = function (_React$Component) {
    (0, _inherits3.default)(LOIOverride, _React$Component);

    function LOIOverride() {
        (0, _classCallCheck3.default)(this, LOIOverride);
        return (0, _possibleConstructorReturn3.default)(this, (LOIOverride.__proto__ || (0, _getPrototypeOf2.default)(LOIOverride)).apply(this, arguments));
    }

    (0, _createClass3.default)(LOIOverride, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.state = {
                overrideSet: this.props.input.value
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.input.value !== this.props.input.value) {
                this.setState({ overrideSet: this.props.input.value });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                id = _props.id,
                input = _props.input,
                meta = _props.meta,
                requirement = _props.requirement,
                field = _props.field,
                intl = _props.intl,
                overrideLabels = _props.overrideLabels;

            return _react3.default.createElement(
                'fieldset',
                null,
                _react3.default.createElement(_components2.LOIModal, null),
                _react3.default.createElement(
                    'div',
                    { className: 'fields-row' },
                    _react3.default.createElement(_components2.CompletedByTag, { requirement: requirement }),
                    _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'div',
                            { className: 'grex-Input' },
                            _react3.default.createElement('input', {
                                id: id,
                                type: 'checkbox',
                                className: 'field check-input',
                                checked: input.value && input.value === 'LETTER_OF_INVITATION_NOT_REQUIRED',
                                onChange: function onChange(event) {
                                    if (input.value === 'LETTER_OF_INVITATION_NOT_REQUIRED') {
                                        input.onChange('');
                                    } else {
                                        input.onChange('LETTER_OF_INVITATION_NOT_REQUIRED');
                                        if (!_this2.state.overrideSet) {
                                            _this2.props.updateUI('LOIModalIsVisible', true);
                                        }
                                    }
                                },
                                disabled: !requirement.editable
                            })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'fields' },
                            _react3.default.createElement(
                                'div',
                                { className: 'check' },
                                _react3.default.createElement(
                                    'label',
                                    { className: 'label', htmlFor: id },
                                    intl.formatMessage(overrideLabels['LETTER_OF_INVITATION_NOT_REQUIRED'])
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return LOIOverride;
}(_react3.default.Component)) || _class) || _class));

var TravelDocuments = function TravelDocuments(_ref) {
    var requirementsByCode = _ref.requirementsByCode,
        intl = _ref.intl,
        initialValues = _ref.initialValues,
        bookingId = _ref.bookingId,
        isFetchingRequirementData = _ref.isFetchingRequirementData,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitSucceeded = _ref.submitSucceeded,
        submitFailed = _ref.submitFailed,
        submitting = _ref.submitting;


    var applicationFormReq = requirementsByCode.APPLICATION_FORM_RECEIVED;
    var criminalBkgrdCheckReq = requirementsByCode.CRIMINAL_BACKGROUND_CHECK_RECEIVED;
    var letterOfRefReq = requirementsByCode.LETTER_OF_REFERENCE_RECEIVED;
    var passportPhotoReq = requirementsByCode.PASSPORT_SIZED_PHOTO_RECEIVED;
    var copyOfPassportSent = requirementsByCode.COPY_OF_PASSPORT_SENT;
    var copyOfVisaSubmitted = requirementsByCode.COPY_OF_VISA_SENT;
    var copyOfPassportLOI = requirementsByCode.COPY_OF_PASSPORT_LOI;

    var contactPrompt = _react3.default.createElement(_components2.DynamicCommunication, { type: 'contactPrompt' });
    var contactPromptWithEmail = _react3.default.createElement(_components2.DynamicCommunication, { type: 'contactPromptWithEmail' });

    var copyOfPassportLOIOverrideValuePath = void 0;

    if (copyOfPassportLOI) {
        copyOfPassportLOIOverrideValuePath = (0, _forms.generateValuePath)({
            requirement: copyOfPassportLOI,
            resourceType: 'overrides'
        });
    }

    return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
            'form',
            null,
            copyOfPassportLOI && copyOfPassportLOIOverrideValuePath && _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormStubText, { stubText: copyOfPassportLOIStub }),
                _react3.default.createElement(_reduxForm.Field, {
                    id: 'copyOfPassportLOIOverride',
                    name: copyOfPassportLOIOverrideValuePath + '.reason.code',
                    component: LOIOverride,
                    requirement: copyOfPassportLOI,
                    bookingId: bookingId,
                    initialValues: initialValues,
                    intl: intl,
                    overrideLabels: _forms2.formOverrides.travelDocuments
                }),
                _react3.default.createElement(_components2.FormSubmit, {
                    handleSubmit: handleSubmit,
                    invalid: invalid,
                    pristine: pristine,
                    submitting: submitting,
                    submitSucceeded: submitSucceeded,
                    hoisted: true,
                    isFetchingRequirementData: isFetchingRequirementData })
            ),
            applicationFormReq && _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormStubText, { stubText: applicationFormStub }),
                _react3.default.createElement(_components2.FieldSet, {
                    className: 'single-col',
                    requirement: applicationFormReq,
                    fields: [{
                        label: applicationFormReq.status === 'INCOMPLETE' ? _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLabels.stubCompletionPrompt', values: { contactPrompt: contactPrompt } }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.stubComplete' })
                    }] })
            ),
            criminalBkgrdCheckReq && _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormStubText, { stubText: criminalBkgrdCheckStub }),
                _react3.default.createElement(_components2.FieldSet, {
                    className: 'single-col',
                    requirement: criminalBkgrdCheckReq,
                    fields: [{
                        label: criminalBkgrdCheckReq.status === 'INCOMPLETE' ? _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLabels.stubCompletionPrompt', values: { contactPrompt: contactPrompt } }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.stubComplete' })
                    }] })
            ),
            letterOfRefReq && _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormStubText, { stubText: letterOfRefStub }),
                _react3.default.createElement(_components2.FieldSet, {
                    className: 'single-col',
                    requirement: letterOfRefReq,
                    fields: [{
                        label: letterOfRefReq.status === 'INCOMPLETE' ? _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLabels.stubCompletionPrompt', values: { contactPrompt: contactPrompt } }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.stubComplete' })
                    }] })
            ),
            passportPhotoReq && _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormStubText, { stubText: passportPhotoStub }),
                _react3.default.createElement(_components2.FieldSet, {
                    className: 'single-col',
                    requirement: passportPhotoReq,
                    fields: [{
                        label: passportPhotoReq.status === 'INCOMPLETE' ? _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLabels.stubCompletionPromptWithEmail', values: { contactPromptWithEmail: contactPromptWithEmail } }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.stubComplete' })
                    }] })
            ),
            copyOfPassportSent && _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormStubText, { stubText: copyOfPassportSentStub }),
                _react3.default.createElement(_components2.FieldSet, {
                    className: 'single-col',
                    requirement: copyOfPassportSent,
                    fields: [{
                        label: copyOfPassportSent.status === 'INCOMPLETE' ? _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLabels.stubCompletionPromptWithEmail', values: { contactPromptWithEmail: contactPromptWithEmail } }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.stubComplete' })
                    }] })
            ),
            copyOfVisaSubmitted && _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormStubText, { stubText: copyOfVisaSubmittedStub }),
                _react3.default.createElement(_components2.FieldSet, {
                    className: 'single-col',
                    requirement: copyOfVisaSubmitted,
                    fields: [{
                        label: copyOfVisaSubmitted.status === 'INCOMPLETE' ? _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLabels.stubCompletionPromptWithEmail', values: { contactPromptWithEmail: contactPromptWithEmail } }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.stubComplete' })
                    }] })
            )
        )
    );
};
TravelDocuments.propTypes = {
    requirementsByCode: _propTypes2.default.object.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _reduxForm.reduxForm)({
    form: 'TravelDocuments',
    enableReinitialize: true
})(TravelDocuments));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/TravelDocuments.js
// module id = 1328
// module chunks = 0